export default __webpack_public_path__ + "static/media/cvod-RP18.9600ea0e.svg";